import { render, staticRenderFns } from "./ListSuveyWebpartTest.vue?vue&type=template&id=c36e47da"
import script from "./ListSuveyWebpartTest.vue?vue&type=script&lang=js"
export * from "./ListSuveyWebpartTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports